
import { computed, defineComponent } from "vue";

import { useStore } from "@/store";
import Button from "@/components/ButtonComp.vue";
import { GET_PROJECTS, DELETE_PROJECT } from "@/store/actions-types";

export default defineComponent({
  name: "ProjectsList",
  setup() {
    const store = useStore();
    store.dispatch(GET_PROJECTS);

    const removeProject = (id: string) => {
      store.dispatch(DELETE_PROJECT, id);
    };

    return {
      projects: computed(() => store.state.project.projects),
      removeProject,
    };
  },
  components: { Button },
});
